import { MapPin } from "lucide-react";

interface ProfileLocationProps {
  location: string | null;
}

export const ProfileLocation = ({ location }: ProfileLocationProps) => {
  if (!location) return null;

  return (
    <div className="flex items-center gap-2 text-gray-600">
      <MapPin className="w-5 h-5" />
      <span>{location}</span>
    </div>
  );
};